export default "__VITE_ASSET__CCe_MhR2__"